import CustomModal from "./UI/CustomModal";
import * as FaIcons from "react-icons/fa";
import lightLogo from "../assets/largelogoLight.png";
import logo from "../assets/logo.png";
import React from "react";
import { useSelector } from "react-redux";
import { themModeSelector } from "../redux/selectors/AuthSelectors";
import { useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import Box from "@mui/material/Box";
import LogoutImg from "../assets/logout.png";
import ShareImg from "../assets/share.png";

const MobileSidebarModal = ({
  showMobileModal,
  setShowMobileModal,
  sidebar,
}) => {
  const history = useHistory();
  const { isDarkMode } = useSelector(themModeSelector);
  const handleLogo = () => {
    history.push("/");
  };

  return (
    <CustomModal
      open={showMobileModal}
      handleClose={() => setShowMobileModal(false)}
      closeIcon={false}
      moreStyle={{
        top: 0,
        transform: "translate(-50%, 0)",
        width: "100%",
        p: 0,
      }}
    >
      <div>
        <nav className="overview-navbar">
          <div className="overview-icon">
            <div style={{ marginLeft: 5 }}>
              <FaIcons.FaBars
                onClick={() => {
                  setShowMobileModal(!showMobileModal);
                }}
                className="sidebar-menu-icon"
                style={{
                  color: isDarkMode ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              />
            </div>
            {!sidebar && (
              <img
                alt="logo"
                className="logo pointer-cursor --p"
                src={isDarkMode ? lightLogo : logo}
                onClick={handleLogo}
              />
            )}
          </div>
        </nav>

        <div className="p-4">
          <Typography>
            <Box sx={{ color: "error.main" }}>
              Sotira’s mobile view is currently under construction! Please log
              in on desktop to fully use Sotira.
            </Box>
          </Typography>
          <div className="menuActoin">
            <img src={ShareImg} alt={"image"} className="menu-img share-img" />
            <span>Share Sotira with a friend</span>
          </div>
          <div className="menuActoin">
            <img src={LogoutImg} alt={"image"} className="menu-img" />
            <span>Log out</span>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default MobileSidebarModal;
